var codeblock_default = {
  "blockStyleSpacing": "N0uNh",
  "codeBlock": "tP7Aj N0uNh",
  "renderedInTable": "_3K5V4"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
